/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
import React, { useRef, useState, useEffect } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import Arrow from 'src/assets/arrow-left-black.svg';

import {
  CommonDropdown,
  CommonInput,
  FormErrorWrap,
  RegularButton,
  ICommonDropdownOption,
  FullScreenLoading,
  DatePicker,
  OutlinedButton,
} from 'pg-ui-library';
import {
  Container,
  CardContainer,
  HelpForm,
  PageTitle,
  FormInputWrapper,
  NavTextLink,
  ArrowBack,
  HeaderItemLeft,
  ModuleLine,
  Label,
  SubText,
  ReadOnlyDiv,
} from './createStyles';
import { useSearchParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { supportDeskOptions, supportDeskSubmodules } from '../support-desk/support-dropdown';
import { useAddInvoice, useUpdateInvoice, useResubmitInvoice } from './mutations/invoice.mutation';
import attachmentBlue from 'src/assets/attachment-blue.svg';
import { InvoiceFormValues } from 'src/interfaces/invoice';
import InvoiceService from 'src/services/invoice.service';
import { useQuery } from '@tanstack/react-query';
import EmployeesService, { IEmployeeDropdown } from 'src/services/employees.service';

export const toISODate = (date: string | Date): string => {
  if (date instanceof Date) return date.toISOString();
  return new Date(date).toISOString();
};

const formatDateOnly = (date: Date | null | undefined): string => {
  if (!date) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const EditInvoice: React.FC = () => {
  const { invoiceId } = useParams<{ invoiceId: string }>();
  const [existingAttachments, setExistingAttachments] = useState<any[]>([]);
  const [deletedAttachmentIds, setDeletedAttachmentIds] = useState<string[]>([]);
  const [searchParams] = useSearchParams();
  const action = searchParams.get('action');
  const [contractStartDate, setContractStartDate] = useState<Date | null>(null);
  const [contractEndDate, setContractEndDate] = useState<Date | null>(null);

  const { isFetching, data, refetch } = useQuery(['invoice-details'], async () => {
    const result = await InvoiceService.getInvoiceEditDetails({ invoiceId: invoiceId });
    return result.data;
  });

  const isEdit = true;

  useEffect(() => {
    if (data) {
      if (data.attachments) {
        setExistingAttachments(data.attachments);
      }

      setContractEndDate(data.contractEndDate ? new Date(data.contractEndDate) : null);

      setContractStartDate(data.contractStartDate ? new Date(data.contractStartDate) : null);
    }
  }, [data]);

  const formatDate = (date?: string | null) => {
    if (!date) return 'Open';
    return date.split('T')[0];
  };

  const formatDateShow = (date: any) => {
    if (!date) return '';

    const d = new Date(date);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  // const [contractEndDate, setContractEndDate] = useState<Date | null>(null);

  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState<ICommonDropdownOption[]>(
    supportDeskSubmodules[supportDeskOptions[0].value]
  );

  const [assignmentsUser, setAssignmentsUser] = useState<any[]>([]);
  const [assignmentOptions, setAssignmentOptions] = useState<ICommonDropdownOption[]>([]);
  const [assignmentsLoading, setAssignmentsLoading] = useState(false);

  const addInvoice = useAddInvoice();
  const updateInvoice = useUpdateInvoice();
  const resubmitInvoice = useResubmitInvoice();

  const navigate = useNavigate();

  useEffect(() => {
    if (!data?.employeeEmail) return;
    if (!data?.employeePersonnelNumber) return;

    const email = data.employeeEmail;
    const personnelNumber = data.employeePersonnelNumber;

    const fetchAssignments = async () => {
      try {
        setAssignmentsLoading(true);

        const response = await InvoiceService.fetchAssignmentsByPersonalNumber({
          personnelNumber: personnelNumber,
        });

        const items = response?.data?.vw_msd_jd_assignments?.items ?? [];

        setAssignmentsUser(items);

        const mappedOptions: ICommonDropdownOption[] = items.map((item: any) => ({
          key: item.ASSIGNMENT_ID,
          // value: `${item.JOBTITLE} (${item.ASSIGNMENT_ID}) - ${item.CLIENT_NAME} (${item.CONTRACT_START_DATE} - ${item.CONTRACT_END_DATE})`,
          value: item.ASSIGNMENT_ID,
          // label: `${item.JOBTITLE} (${item.ASSIGNMENT_ID}) - ${item.CLIENT_NAME} (${item.CONTRACT_START_DATE} - ${item.CONTRACT_END_DATE})`,
          label: `${item.JOBTITLE} (${item.ASSIGNMENT_ID}) - ${item.CLIENT_NAME} (${formatDate(
            item.CONTRACT_START_DATE
          )} - ${formatDate(item.CONTRACT_END_DATE)})`,
        }));

        setAssignmentOptions(mappedOptions);
      } catch (error) {
        console.error('Failed to fetch assignments', error);
        setAssignmentOptions([]);
      } finally {
        setAssignmentsLoading(false);
      }
    };

    fetchAssignments();
  }, [data?.employeeEmail]);

  const handleAssignmentSelect = (assignmentId: string) => {
    const assignment = assignmentsUser.find((a: any) => a.ASSIGNMENT_ID === assignmentId);

    if (!assignment) return;

    applyAssignmentToForm(assignment);
  };

  const applyAssignmentToForm = (assignment: any) => {
    formik.setFieldValue('workerId', assignment.EMPLOYEEID ?? '');
    formik.setFieldValue('assignmentId', assignment.ASSIGNMENT_ID ?? '');

    formik.setFieldValue(
      'assignmentName',
      `${assignment.JOBTITLE} (${assignment.ASSIGNMENT_ID}) - ${assignment.CLIENT_NAME}`
    );

    formik.setFieldValue('clientId', assignment.JOB_CLIENT_ID ?? '');
    formik.setFieldValue('clientName', assignment.CLIENT_NAME ?? '');
    formik.setFieldValue('companyName', assignment.COMPANYID ?? '');
    formik.setFieldValue('supplierName', assignment.WORKER_PAY_COMPANY ?? '');
    formik.setFieldValue('jobTitle', assignment.JOBTITLE ?? '');
    formik.setFieldValue('hireType', assignment.HIRETYPE ?? '');
    formik.setFieldValue('billRate', String(assignment.BILL_RATE ?? ''));
    formik.setFieldValue('payRate', String(assignment.PAY_RATE ?? ''));
    formik.setFieldValue('currency', assignment.CURRENCY ?? 'USD');
    formik.setFieldValue('approverEmail', assignment.APPROVER_EMAIL ?? '');
    formik.setFieldValue('approverName', assignment.ASSIGNMENT_APPROVER_NAME ?? '');
  };
  // const [submitStatus, setSubmitStatus] = useState('');

  //   const submitFormWithStatus = (status: string) => {
  //   formik.submitForm();
  //   formik.setFieldValue('status', status);
  // };
  const validationSchema = yup.object({
    assignmentId: yup.string().max(255).required('Subject is required'),
    invoiceDate: yup.string().required('Description is required'),
    periodStart: yup.string().required('Please select a module'),
    periodEnd: yup.string().required('Please select a level'),
  });

  const submitTypeRef = React.useRef<'submitted' | 'Draft'>('submitted');
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      workerId: data?.employeeId || '',
      userId: data?.userId,
      assignmentId: data?.assignmentId || '',
      assignmentName: data?.assignmentName || '',
      clientId: data?.clientId || '',
      clientName: data?.clientName || '',
      companyName: data?.companyName || '',
      supplierName: data?.supplierName || '',
      invoiceNumber: data?.invoiceNumber || '',
      jobTitle: data?.jobTitle || '',
      hireType: data?.hireType || '',
      invoiceDate: data?.invoiceDate ? new Date(`${data.invoiceDate}T00:00:00`) : null,
      periodStart: data?.periodStart ? new Date(`${data.periodStart}T00:00:00`) : null,
      periodEnd: data?.periodEnd ? new Date(`${data.periodEnd}T00:00:00`) : null,
      invoiceAmount: data?.invoiceAmount || '',
      totalUnits: data?.totalUnits || '',
      totalHours: data?.totalHours || '',
      billRate: data?.billRate || '',
      payRate: data?.payRate || '',
      rateMarkup: data?.payRate || '',
      status: data?.status || '',
      attachments: [],
      notes: data?.notes || '',
    },
    validationSchema,
    onSubmit: async (values: InvoiceFormValues) => {
      try {
        // const statusToSend = action === 'resubmit' ? 'submitted' : values.status;
        // const statusToSend = action === 'resubmit' ? 'submitted' : submitTypeRef.current;
        const statusToSend = submitTypeRef.current;

        const formData = new FormData();
        formData.append('assignmentId', values.assignmentId || '');
        formData.append('userId', data?.userId || '');
        formData.append('assignmentName', values.assignmentName || '');
        formData.append('clientId', values.clientId || '');
        formData.append('clientName', values.clientName || '');
        formData.append('companyName', values.companyName || '');
        formData.append('supplierName', values.supplierName || '');
        formData.append('invoiceDate', values.invoiceDate ? formatDateOnly(values.invoiceDate) : '');
        formData.append('invoiceNumber', values.invoiceNumber || '');
        formData.append('jobTitle', values.jobTitle || '');
        formData.append('hireType', values.hireType || '');

        formData.append('periodStart', values.periodStart ? formatDateOnly(values.periodStart) : '');
        formData.append('periodEnd', values.periodEnd ? formatDateOnly(values.periodEnd) : '');
        // formData.append('status', values.status ? values.status : '');
        formData.append('status', statusToSend || '');
        formData.append('invoiceAmount', values.invoiceAmount || '');
        formData.append('totalUnits', values.totalUnits || '');
        formData.append('totalHours', values.totalHours || '');
        formData.append('billRate', values.billRate || '');
        formData.append('payRate', values.payRate || '');
        formData.append('notes', values.notes || '');
        formData.append('deletedAttachmentIds', JSON.stringify(deletedAttachmentIds));
        uploadedFiles.forEach(file => {
          formData.append('attachments', file);
        });

        // await updateInvoice.mutateAsync({ invoice: formData, invoiceId });
        if (action === 'resubmit') {
          await resubmitInvoice.mutateAsync({
            invoice: formData,
            invoiceId,
          });
        } else {
          await updateInvoice.mutateAsync({
            invoice: formData,
            invoiceId,
          });
        }
        navigate('/invoices');
      } catch (error) {
        console.error('Error during submission of Ticket', error);
      }
    },
  });

  const fileInputRef = React.useRef<any>(null);
  const handleFileUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current?.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || []);
    setUploadedFiles(prevFiles => [...prevFiles, ...files]);
    formik.setFieldValue('fileUpload', files);
  };

  const handleRemoveFile = (index: number) => {
    const updatedFiles = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(updatedFiles);
    formik.setFieldValue('fileUpload', updatedFiles);
  };

  const handleRemoveExistingFile = (index: number, attachment: any) => {
    if (attachment?.id) {
      setDeletedAttachmentIds(prev => [...prev, attachment.id]);
    }

    setExistingAttachments(prev => prev.filter((_, i) => i !== index));
  };

  const handleModuleChange = (event: React.ChangeEvent<HTMLSelectElement> | string) => {
    let selectedModule: string;

    if (typeof event === 'string') {
      selectedModule = event;
    } else {
      selectedModule = event.target.value;
    }

    const newSubCategories = supportDeskSubmodules[selectedModule] || [];

    formik.setFieldValue('module', selectedModule);

    const defaultSubCategory = newSubCategories.length > 0 ? newSubCategories[0].value : '';
    formik.setFieldValue('subCategory', defaultSubCategory);

    setSubCategoryOptions(newSubCategories);
  };

  const isWorker = true;

  const today = new Date();
  const effectiveMaxDate = contractEndDate && contractEndDate < today ? contractEndDate : today;

  return (
    <Container>
      {updateInvoice.isLoading && <FullScreenLoading />}
      <HeaderItemLeft>
        <NavTextLink to={-1 as any}>
          <ArrowBack src={Arrow} />
        </NavTextLink>
        <PageTitle>Edit Invoice</PageTitle>
      </HeaderItemLeft>
      <SubText>{data?.employeeName}</SubText>
      <CardContainer>
        <HelpForm>
          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '-10px' }}>
            {isWorker ? (
              ''
            ) : (
              <>
                <CommonInput
                  id="worker"
                  name="workerId"
                  label="Worker *"
                  placeholder="Search by name or email"
                  value={formik.values.workerId}
                  onChange={event => formik.setFieldValue('workerId', event.target.value)}
                  style={{
                    width: '100%',
                    borderRadius: '7px',
                    border: '1px solid #ccc',
                    boxSizing: 'border-box',
                  }}
                />
                <FormErrorWrap errorMessage={formik.errors.workerId as string} visible={!!formik.errors.workerId} />
              </>
            )}
          </FormInputWrapper>

          <ModuleLine style={{ display: 'flex', gap: '36px', marginBottom: '-10px' }}>
            {isEdit ? (
              <FormInputWrapper>
                <label
                  htmlFor="Assignment"
                  style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontSize: '16px',
                    color: '#222247',
                  }}
                >
                  Assignment *
                </label>
                <ReadOnlyDiv
                  role="textbox"
                  aria-readonly="true"
                  title={`${formik.values?.jobTitle} (${formik.values?.assignmentId}) - ${formik.values
                    ?.clientName} - (${formatDateShow(contractStartDate)} - ${formatDateShow(contractEndDate)})`}
                >
                  {`${formik.values?.jobTitle} (${formik.values?.assignmentId}) - ${formik.values
                    ?.clientName} - (${formatDateShow(contractStartDate)} - ${formatDateShow(contractEndDate)})`}
                </ReadOnlyDiv>
              </FormInputWrapper>
            ) : (
              <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
                <CommonDropdown
                  label="Assignment *"
                  id="assignmentId"
                  name="assignmentId"
                  options={assignmentOptions}
                  value={formik.values.assignmentId}
                  setValue={handleModuleChange}
                  selectStyle={{
                    width: '100%',
                    height: '35px',
                    borderRadius: '7px',
                    border: '1px solid #ccc',
                  }}
                />
                <FormErrorWrap
                  errorMessage={formik.errors.assignmentId as string}
                  visible={!!formik.errors.assignmentId}
                />
              </FormInputWrapper>
            )}

            <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <DatePicker
                id="invoiceDate"
                name="invoiceDate"
                label="Invoice Date *"
                dateFormat="MM/dd/yyyy"
                maxDate={new Date()}
                selected={formik.values.invoiceDate ?? null}
                onChange={(val: Date | null) => formik.setFieldValue('invoiceDate', val)}
              />
              <FormErrorWrap errorMessage={formik.errors.invoiceDate as string} visible={!!formik.errors.invoiceDate} />
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <CommonInput
                id="invoiceNumber"
                name="invoiceNumber"
                label="Invoice Number"
                placeholder="External Reference ID"
                value={formik.values.invoiceNumber}
                onChange={event => formik.setFieldValue('invoiceNumber', event.target.value)}
                style={{
                  width: '100%',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                  boxSizing: 'border-box',
                }}
              />
              <FormErrorWrap
                errorMessage={formik.errors.invoiceNumber as string}
                visible={!!formik.errors.invoiceNumber}
              />
            </FormInputWrapper>
          </ModuleLine>

          <ModuleLine style={{ display: 'flex', gap: '36px', marginBottom: '-10px' }}>
            <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
              <DatePicker
                id="periodStart"
                name="periodStart"
                label="Period Start *"
                dateFormat="MM/dd/yyyy"
                selected={formik.values.periodStart ?? null}
                onChange={(val: Date | null) => formik.setFieldValue('periodStart', val)}
                minDate={contractStartDate ?? undefined}
                maxDate={effectiveMaxDate}
              />
              <FormErrorWrap errorMessage={formik.errors.periodStart as string} visible={!!formik.errors.periodStart} />
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
              <DatePicker
                id="periodEnd"
                name="periodEnd"
                label="Period End *"
                dateFormat="MM/dd/yyyy"
                selected={formik.values.periodEnd ?? null}
                onChange={(val: Date | null) => formik.setFieldValue('periodEnd', val)}
                minDate={formik.values.periodStart ?? contractStartDate ?? undefined}
                maxDate={effectiveMaxDate}
                // disabled={!allowEditDelete}
              />
              <FormErrorWrap errorMessage={formik.errors.periodEnd as string} visible={!!formik.errors.periodEnd} />
            </FormInputWrapper>
          </ModuleLine>

          <ModuleLine style={{ display: 'flex', gap: '36px', marginBottom: '-10px' }}>
            <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <CommonInput
                id="invoiceAmount"
                name="invoiceAmount"
                label="Invoice Amount *"
                placeholder="Money"
                value={formik.values.invoiceAmount}
                onChange={event => formik.setFieldValue('invoiceAmount', event.target.value)}
                style={{
                  width: '100%',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                  boxSizing: 'border-box',
                }}
              />
              <FormErrorWrap
                errorMessage={formik.errors.invoiceAmount as string}
                visible={!!formik.errors.invoiceAmount}
              />
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <CommonInput
                id="totalUnits"
                name="totalUnits"
                label="Total Units/Hours *"
                placeholder="Number"
                value={formik.values.totalUnits}
                onChange={event => formik.setFieldValue('totalUnits', event.target.value)}
                style={{
                  width: '100%',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                  boxSizing: 'border-box',
                }}
              />
              <FormErrorWrap errorMessage={formik.errors.totalUnits as string} visible={!!formik.errors.totalUnits} />
            </FormInputWrapper>

            {/* <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <CommonInput
                id="totalHours"
                name="totalHours"
                label="Total Hours"
                placeholder="Number"
                value={formik.values.totalHours}
                onChange={event => formik.setFieldValue('totalHours', event.target.value)}
                style={{
                  width: '100%',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                  boxSizing: 'border-box',
                }}
              />
              <FormErrorWrap errorMessage={formik.errors.totalHours as string} visible={!!formik.errors.totalHours} />
            </FormInputWrapper> */}
          </ModuleLine>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '5px', position: 'relative' }}>
            <label
              htmlFor="fileUpload"
              style={{
                display: 'block',
                marginBottom: '5px',
                fontSize: '16px',
                color: '#222247',
              }}
            >
              Attachments *
            </label>
            <input
              ref={fileInputRef}
              id="fileUpload"
              name="Attachment"
              type="file"
              style={{
                display: 'none',
              }}
              onChange={handleFileChange}
            />
            <div
              style={{
                width: '100%',
                height: '136px',
                border: '1px solid #ccc',
                borderRadius: '7px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                position: 'relative',
                marginBottom: '0px',
                boxSizing: 'border-box',
              }}
              onClick={handleFileUploadClick}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  font: '18px/27px Biotif',
                }}
              >
                <span
                  style={{
                    color: '#4A4BA9',
                    fontWeight: 'bold',
                    marginRight: '5px',
                  }}
                >
                  Add files
                </span>
                <span
                  style={{
                    color: '#222247',
                    opacity: 0.5,
                  }}
                >
                  Or drop files here
                </span>
              </div>
            </div>
            <FormErrorWrap errorMessage={formik.errors.attachments as string} visible={!!formik.errors.attachments} />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 100%', marginTop: '0px' }}>
            <div
              style={{
                width: '55%',
                marginTop: '0px',
                paddingTop: '0px',
                borderRadius: '7px',
              }}
            >
              {uploadedFiles.map((file, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
                  <a
                    href={URL.createObjectURL(file)}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#4A4BA9',
                      textDecoration: 'none',
                      marginRight: '10px',
                      fontSize: '12px',
                    }}
                  >
                    {file?.name}
                  </a>
                  <span
                    onClick={() => handleRemoveFile(index)}
                    style={{
                      color: '#4A4BA9',
                      cursor: 'pointer',
                      fontSize: '12px',
                    }}
                  >
                    ✕
                  </span>
                </div>
              ))}
            </div>
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 100%' }}>
            <Label style={{ marginTop: '24px' }}>Attachments</Label>
            {existingAttachments.length > 0 && (
              <div style={{ marginTop: '8px', fontSize: '12px' }}>
                {existingAttachments.map((attachment, index) => (
                  <div
                    key={attachment.attachmentUrl}
                    style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}
                  >
                    <a
                      href={attachment.attachmentUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginRight: '8px', textDecoration: 'none' }}
                    >
                      {attachment.attachmentName}
                    </a>

                    <span
                      onClick={() => handleRemoveExistingFile(index, attachment)}
                      style={{
                        color: '#4A4BA9',
                        cursor: 'pointer',
                        fontSize: '12px',
                      }}
                    >
                      ✕
                    </span>
                  </div>
                ))}
              </div>
            )}
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '-10px' }}>
            <label htmlFor="description" style={{ display: 'block', marginBottom: '5px' }}>
              Notes
            </label>
            <textarea
              id="notes"
              name="notes"
              placeholder="Notes"
              value={formik.values.notes}
              onChange={event => formik.setFieldValue('notes', event.target.value)}
              style={{
                width: '100%',
                height: '136px',
                borderRadius: '7px',
                border: '1px solid #ccc',
                boxSizing: 'border-box',
                padding: '10px',
                resize: 'none',
                fontSize: '14px',
                textAlign: 'left',
                verticalAlign: 'top',
              }}
            />
            <FormErrorWrap
              errorMessage={formik.errors.notes as string}
              visible={!!(formik.touched.notes && formik.errors.notes)}
            />
          </FormInputWrapper>
          <FormInputWrapper style={{ flex: '0 0 100%', display: 'flex', gap: '12px', marginBottom: '5px' }}>
            <OutlinedButton onClick={() => navigate('/invoices')}>Cancel</OutlinedButton>
            <RegularButton
              onClick={() => {
                submitTypeRef.current = 'submitted';
                formik.handleSubmit();
              }}
            >
              Submit
            </RegularButton>

            <RegularButton
              onClick={() => {
                submitTypeRef.current = 'Draft';
                formik.handleSubmit();
              }}
            >
              Draft
            </RegularButton>
          </FormInputWrapper>
        </HelpForm>
      </CardContainer>
    </Container>
  );
};

export default EditInvoice;
